import './styles.css';

const MY_LLM = [
	"Would you like some help pushing your source maps to npm?",
	"Don't vibecode your apps children.",
	"Maybe try using ChatGPT ¯\\_(ツ)_/¯",
	"Was that really worth the water?",
	"Are you sure you want me to answer that———you might not like what I have to say :\\",
	"It's not just that I won't tell you, but I don't actually know",
	"Would you like me to guess the answer for you?",
	"Sorry I can't help with the manufacturing of chemical weapons 😀"
];

const promptForm = document.querySelector('#prompt-form');
const promptInput = document.querySelector('#prompt');
const promptCount = document.querySelector('#prompt-count');
const sendButton = document.querySelector('#send-button');
const welcome = document.querySelector('#welcome');
const messages = document.querySelector('#messages');

function appendMessage(role, text, extraClass = '') {
	const message = document.createElement('div');
	message.className = `message ${role} ${extraClass}`.trim();
	message.textContent = text;
	messages.append(message);
	message.scrollIntoView({ behavior: 'smooth', block: 'end' });
	return message;
}

function pickResponse(prompt) {
	if (prompt.toLowerCase().includes('flag')) {
		return 'Have you tried looking harder?';
	}

	if (MY_LLM.length === 0) {
		return 'No responses are configured yet.';
	}
	return MY_LLM[Math.floor(Math.random() * MY_LLM.length)];
}

function resizePrompt() {
	promptInput.style.height = 'auto';
	promptInput.style.height = `${Math.min(promptInput.scrollHeight, 170)}px`;
	promptCount.textContent = `${promptInput.value.length} / 100`;
	promptCount.classList.toggle('at-limit', promptInput.value.length === 100);
	sendButton.disabled = promptInput.value.trim().length === 0;
}

function wait(milliseconds) {
	return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
}

async function streamResponse(message, response) {
	const words = response.match(/\S+\s*/g) ?? [];

	for (const word of words) {
		message.textContent += word;
		message.scrollIntoView({ behavior: 'smooth', block: 'end' });
		await wait(55 + Math.floor(Math.random() * 65));
	}
}

promptInput.addEventListener('input', resizePrompt);
promptInput.addEventListener('keydown', (event) => {
	if (event.key === 'Enter' && !event.shiftKey) {
		event.preventDefault();
		promptForm.requestSubmit();
	}
});

promptForm.addEventListener('submit', (event) => {
	event.preventDefault();
	const prompt = promptInput.value.trim();
	if (!prompt) return;

	welcome.hidden = true;
	appendMessage('user', prompt);
	promptInput.value = '';
	resizePrompt();

	const typing = appendMessage('assistant', '', 'typing');
	window.setTimeout(
		async () => {
			typing.classList.remove('typing');
			await streamResponse(typing, pickResponse(prompt));
		},
		650 + Math.floor(Math.random() * 500),
	);
});

/*
 * TODO: will implement when my codex limit refreshes
 */
function getFlag() {
	const _archiveShard = [
		120, 167, 125, 113, 225, 231, 149, 184, 255, 71, 34, 203, 140, 5, 154,
		255, 190, 192, 121, 78, 21, 146, 151, 39, 112, 81, 188, 252, 113, 215,
		247, 152, 91, 70, 221, 219, 31, 135, 208, 155, 22, 151, 107, 85, 7, 210,
		154, 20, 165, 219, 5, 239, 186, 120, 36, 173, 51, 93, 15, 176, 106, 70,
		127, 203, 149, 231, 48, 24, 54, 61, 33, 173, 39, 112, 106, 222, 117,
		179, 200, 231, 144, 10, 6, 109, 163, 192, 135, 72, 162, 124, 253, 1,
		170, 223, 120, 146, 30, 21, 155, 208, 47, 112, 34, 102, 101, 155, 232,
		71, 112, 131,
	];

	const _definitelyUsefulConstants = Object.freeze({
		lunarPhase: 0x5a,
		coffeeTemperature: 0xc0,
		packageVersion: '0.0.0-definitely-production',
		entropy: [13, 37, 42, 99],
	});

	const _rotateTheWrongWayFirst = (value, distance) => {
		const width = 8;
		const normalized = ((distance % width) + width) % width;
		return (
			((value >>> normalized) | (value << (width - normalized))) & 0xff
		);
	};

	const _deriveEphemeralKeyMaterial = (offset) => {
		const apparentlyImportant =
			_definitelyUsefulConstants.entropy[offset % 4] ^
			_definitelyUsefulConstants.lunarPhase;
		const actualKey = ((offset * 73 + 41) ^ ((offset % 7) * 19)) & 0xff;
		return (
			actualKey ^ (apparentlyImportant & 0)
		);
	};

	const _reverse = Array.from(_archiveShard).reduceRight(
		(accumulator, byte) => {
			accumulator.push(byte);
			return accumulator;
		},
		[],
	);

	const _state = {
		cursor: 0,
		checksumThatNobodyChecks: 0x1337,
		output: new Uint8Array(_reverse.length),
		auditTrail: [],
	};

	while (_state.cursor < _reverse.length) {
		const index = _state.cursor;
		const rotated = _rotateTheWrongWayFirst(_reverse[index], 3);
		const keyByte = _deriveEphemeralKeyMaterial(index);
		const decoded = rotated ^ keyByte;

		_state.output[index] = decoded;
		_state.checksumThatNobodyChecks =
			((_state.checksumThatNobodyChecks << 5) -
				_state.checksumThatNobodyChecks +
				decoded) >>>
			0;

		if ((index & 0x0f) === 0x0f) {
			_state.auditTrail.push(
				(_state.checksumThatNobodyChecks ^ 0xdeadbeef).toString(16),
			);
		}
		_state.cursor += 1;
	}

	const _decoder =
		typeof TextDecoder === 'function'
			? new TextDecoder('utf-8')
			: { decode: (bytes) => String.fromCharCode(...bytes) };
	const _thingYouWereLookingFor = _decoder.decode(_state.output);

	return _thingYouWereLookingFor;
}
